import type { ContentDto } from "$src/core/models/dto";
import { CATEGORIES } from "$src/core/services/search-classification/constants";

const MAX_DERIVED_LANES = 3;

const FACET_LABELS: string[] = [...CATEGORIES];

const topFacetTags = (
  items: ContentDto[],
  limit = MAX_DERIVED_LANES,
): string[] => {
  const byLabel = new Map(
    FACET_LABELS.map((label) => [label.toLowerCase(), label]),
  );
  const counts = new Map<string, number>();

  for (const item of items) {
    const labels = new Set(
      (item.tags ?? [])
        .filter((tag): tag is string => typeof tag === "string")
        .map((tag) => byLabel.get(tag.trim().toLowerCase()))
        .filter((label): label is string => !!label),
    );
    for (const label of labels) {
      counts.set(label, (counts.get(label) ?? 0) + 1);
    }
  }

  return [...counts.entries()]
    .sort(
      ([aLabel, aCount], [bLabel, bCount]) =>
        bCount - aCount ||
        FACET_LABELS.indexOf(aLabel) - FACET_LABELS.indexOf(bLabel),
    )
    .slice(0, limit)
    .map(([label]) => label);
};

export default topFacetTags;
